import { stockApi } from '$api'
import { ICategory, ISubcategory } from '$models'
import { getActiveCompanySettings, singletonQueryClient } from '$utils'
import { CategoryPatchRequest } from '@loadedhub/loaded-stock-api-sdk'

enum QueryKeys {
  getAllCategories = 'getAllCategories',
  getAllSubcategories = 'getAllSubcategories',
}

/**
 * Retrieves all categories
 * @returns an list of categories
 */
export const getAllCategories = async (): Promise<ICategory[]> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) return []

  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.getAllCategories],
    queryFn: async () => {
      return await stockApi.getCategories()
    },
  })
}

/**
 * Retrieves all subcategories
 * @returns an list of subcategories
 */
export const getAllSubcategories = async (): Promise<ISubcategory[]> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) return []

  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.getAllSubcategories],
    queryFn: async () => {
      return await stockApi.getSubcategories()
    },
  })
}

export const updateCategoryExternalAccountCode = async (
  categoryId: string,
  externalAccountCode: string | undefined
): Promise<ICategory | null> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) return null

  return await stockApi.updateCategoryExternalAccountCode(
    categoryId,
    new CategoryPatchRequest({ externalAccountCode })
  )
}
